import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import FrequentlyBoughtTogetherWidget from './FrequentlyBoughtTogetherWidget.component';
import BuyTogetherQuery from 'Query/BuyTogether.query';
import CartQuery from 'Query/Cart.query';
import { fetchQuery, fetchMutation } from 'Util/Request';
import BrowserDatabase from 'Util/BrowserDatabase';
import { showNotification } from 'Store/Notification/Notification.action';

const CartDispatcher = import(
    /* webpackMode: "lazy", webpackChunkName: "dispatchers" */ 'Store/Cart/Cart.dispatcher'
    );

export const mapDispatchToProps = (dispatch) => ({
    showNotification: (type, message) => dispatch(showNotification(type, message)),
    updateCartData: (cartData) =>
        CartDispatcher.then(({ default: dispatcher }) =>
            dispatcher._updateCartData(cartData, dispatch)
        ),
});

class FrequentlyBoughtTogetherWidgetContainer extends PureComponent {
    state = {
        products: [],
        isLoading: true,
        error: null,
        currency: '',
        isAdding: false,
    };

    componentDidMount() {
        const { skus } = this.props;
        const skuList = JSON.parse(skus.replace(/'/g, '"'));
        this.fetchProducts(skuList);
    }

    fetchProducts = (skuList) => {
        fetchQuery(BuyTogetherQuery.getProducts(skuList))
            .then(({ getGroupProducts: { products } }) => {
                if (!products.length) {
                    throw new Error('No products found for the given SKUs.');
                }

                // Just pick currency from the first product for consistency
                const currency =
                    products[0]?.price_range.minimum_price.final_price.currency || 'USD';

                this.setState({ products, currency, isLoading: false });
            })
            .catch((error) => {
                console.error('Error fetching products:', error);
                this.setState({ error, isLoading: false });
            });
    };

    handleAddToCart = (selectedSkus) => {
        const { showNotification } = this.props;
        const quote_id = BrowserDatabase.getItem('guest_quote_id');

        // If no products selected, show a notification
        if (!selectedSkus.length) {
            showNotification('error', __('No products selected.'));
            return;
        }

        const input = {
            sku: selectedSkus,
            quote_id,
        };

        this.setState({ isAdding: true });

        fetchMutation(BuyTogetherQuery.addProducts(input))
            .then(({ saveGroupProducts: { status } }) => {
                if (status === 'success') {
                    this.fetchCartData();
                } else {
                    showNotification('error', __('Failed to add products to cart.'));
                    this.setState({ isAdding: false });
                }
            })
            .catch((error) => {
                console.error('Error adding products to cart:', error);
                showNotification('error', __('An error occurred. Try again.'));
                this.setState({ isAdding: false });
            });
    };

    fetchCartData = () => {
        const { updateCartData, showNotification } = this.props;
        const quote_id = BrowserDatabase.getItem('guest_quote_id');

        fetchQuery(CartQuery.getCartQuery(quote_id))
            .then(({ cartData }) => {
                updateCartData(cartData);
                showNotification('success', __('All available products from your selection have been added to the cart!'));
                this.setState({ isAdding: false });
            })
            .catch((error) => {
                console.error('Error fetching cart data:', error);
                showNotification('error', __('Failed to update cart.'));
                this.setState({ isAdding: false });
            });
    };

    containerProps = () => {
        const { products, isLoading, error, currency, isAdding } = this.state;

        return {
            products,
            isLoading,
            error,
            currency,
            title: this.props.title,
            isAdding
        };
    };

    containerFunctions = {
        handleAddToCart: this.handleAddToCart,
    };

    render() {
        return (
            <FrequentlyBoughtTogetherWidget
                {...this.containerFunctions}
                {...this.containerProps()}
            />
        );
    }
}

export default connect(null, mapDispatchToProps)(FrequentlyBoughtTogetherWidgetContainer);
